import { Layers } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { CLASSIFICATION_CATALOG_PERMISSIONS } from '@/lib/permissions'

import {
  entityClassificationCatalogReleaseRoute,
  entityClassificationCatalogReleasesRoute,
  entityClassificationCatalogsRoute,
} from './routes'

export const classificationCatalogsModule = defineModule({
  routes: [
    entityClassificationCatalogsRoute,
    entityClassificationCatalogReleasesRoute,
    entityClassificationCatalogReleaseRoute,
  ],
  navigation: {
    settings: [
      {
        to: '/$entityId/settings/classification-catalogs',
        label: 'Classification catalogs',
        icon: Layers,
        permission: CLASSIFICATION_CATALOG_PERMISSIONS.read,
        section: 'settings',
        order: 35,
      },
    ],
  },
})
